import {
  MolsonButton,
  MolsonDialog,
  MolsonDialogActions,
  MolsonDialogHeader
} from '@components/reusable'

export type AddAttachmentDialogProps = {
  cancelBtnText: string
  isDialogOpen: boolean
  nextBtnText: string
  onClickNext: () => void
  onClose: () => void
  subTitle: string
  title: string
}

export const AddAttachmentDialog = ({
  cancelBtnText,
  isDialogOpen,
  nextBtnText,
  onClickNext,
  onClose,
  subTitle,
  title
}: AddAttachmentDialogProps) => {
  return (
    <MolsonDialog
      fullWidth={true}
      maxWidth="sm"
      onClose={onClose}
      open={isDialogOpen}
    >
      <MolsonDialogHeader
        displayDivider={false}
        subTitle={subTitle}
        title={title}
      />
      <MolsonDialogActions displayDivider={false}>
        <MolsonButton color="secondary" onClick={onClose} variant="outlined">
          {cancelBtnText}
        </MolsonButton>
        <MolsonButton onClick={onClickNext} type="submit" variant="contained">
          {nextBtnText}
        </MolsonButton>
      </MolsonDialogActions>
    </MolsonDialog>
  )
}
